
const screenSizeQueries = {
    desktop: 'screen and (min-width: 900px)',
    desktopLarge: 'screen and (min-width: 1200px)',
    desktopSmall: 'screen and (max-width: 1199px) and (min-width: 900px)',
    tablet: 'screen and (max-width: 899px) and (min-width: 500px)',
    tabletLarge: 'screen and (max-width: 899px) and (min-width: 700px)',
    tabletSmall: 'screen and (max-width: 699px) and (min-width: 500px)',
    mobile: 'screen and (max-width: 499px)',
    mobileLarge: 'screen and (max-width: 499px) and (min-width: 350px)',
    mobileSmall: 'screen and (max-width: 349px)',
};

export default screenSizeQueries;
